import { CountryEntity } from '../entities/country-entity';

export default class State {
  items: Array<CountryEntity> = [];
}
